import { useLingui } from '@lingui/react/macro'
import { CantileverButton } from 'components/CantileverButton'
import { Button } from 'designSystem/components/Button'
import { ChartTooltip } from 'features/timeSeries/components/ChartTooltip'
import { Camera } from 'lucide-react'
import React, { useCallback } from 'react'

interface ExportPngButtonProps {
  getCanvas: () => HTMLCanvasElement | null | undefined
  appearance?: 'hud' | 'toolbar'
}

export const ExportPngButton: React.FC<ExportPngButtonProps> = ({
  getCanvas,
  appearance = 'hud',
}) => {
  const { t } = useLingui()

  const handleExportPng = useCallback(() => {
    const canvas = getCanvas()
    if (!canvas) return
    const link = document.createElement('a')
    link.download = 'time-series-chart.png'
    link.href = canvas.toDataURL('image/png')
    link.click()
  }, [getCanvas])

  if (appearance === 'toolbar') {
    return (
      <ChartTooltip label={t`Export PNG`} side='bottom'>
        <Button
          variant='inputRaised'
          size='icon-lg'
          aria-label={t`Export PNG`}
          onClick={handleExportPng}>
          <Camera size={18} strokeWidth={1.5} />
        </Button>
      </ChartTooltip>
    )
  }

  return (
    <ChartTooltip
      label={t`Export PNG`}
      side='top'
      style={{ display: 'inline-flex' }}>
      <CantileverButton iconOnly ghost size='small' onClick={handleExportPng}>
        <Camera size={16} />
      </CantileverButton>
    </ChartTooltip>
  )
}
